/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/Layout'

const componentsRouter = {
    path: '/report',
    component: Layout,
    name: 'Report',
    menuid: 44,
    systemtypeid: 0,
    meta: {
      title: 'ReportTitle',
      icon: 'list'
    },
    children: [   
      {
        path: 'keyquery',
        component: () => import('@/views/report/keyquery'),
        name: 'KeyQuery',
        menuid: 157,
        systemtypeid: 0,
        meta: {title: 'KeyQuery', icon: 'clipboard'}
      }, 
      {
        path: 'liftlog',
        component: () => import('@/views/report/liftlog'),
        name: 'LiftLog',
        menuid: 158,
        systemtypeid: 0,
        meta: {title: 'LiftLog', icon: 'message'}
      }, 
      {
        path: 'doorlog',
        component: () => import('@/views/report/doorlog'),
        name: 'DoorLog',
        menuid: 159,
        systemtypeid: 0,
        meta: {title: 'DoorLog', icon: 'message'}
      },  

      {
        path: 'liftlogsum',
        component: () => import('@/views/report/liftlogsum'),
        name: 'LiftLogSumTotal',
        menuid: 168,
        systemtypeid: 0,
        meta: {title: 'LiftLogSumTotal', icon: 'chart'}
      },  

      {
        path: 'doorlogsum',
        component: () => import('@/views/report/doorlogsum'),
        name: 'DoorLogSumTotal',
        menuid: 167,
        systemtypeid: 0,
        meta: {title: 'DoorLogSumTotal', icon: 'chart'}
      },  
      {
        path: 'userapply',
        component: () => import('@/views/report/userapply'),
        name: 'UserApplyTotal',
        menuid: 160,
        systemtypeid: 0,
        meta: {title: 'UserApplyTotal', icon: 'edit'}
      }, 
      {
        path: 'visitorapply',
        component: () => import('@/views/report/visitorapply'),
        name: 'VisitorApplyTotal',
        menuid: 161,
        systemtypeid: 0,
        meta: {title: 'VisitorApplyTotal', icon: 'edit'}
      },  
    ]
  }

export default componentsRouter



// WEBPACK FOOTER //
// ./src/router/modules/report.js